import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export default function Story() {
  const { t } = useLang();

  return (
    <section id="story" data-testid="story-section" className="relative py-32 md:py-48 bg-[#FAFAF7]">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C48E66] mb-8" data-testid="story-eyebrow">{t.story.eyebrow}</p>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#112A46] leading-[1.02] tracking-tight font-light max-w-3xl" data-testid="story-title">
            {t.story.title_1}<span className="italic">{t.story.title_italic}</span>{t.story.title_2}
          </h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-4xl">
            <div className="space-y-5">
              <p className="text-[#5C665F] leading-relaxed text-base md:text-lg" data-testid="story-p1">{t.story.p1}</p>
              <p className="text-[#5C665F] leading-relaxed text-base md:text-lg" data-testid="story-p2">{t.story.p2}</p>
            </div>
            <p className="text-[#5C665F] leading-relaxed text-base md:text-lg" data-testid="story-p3">{t.story.p3}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
